"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const url_1 = require("url");
const querystring_1 = require("querystring");
const decodeUriComponent = require('decode-uri-component');
const config_1 = require("./config");
const utils_1 = require("./utils");
class ServiceRequester {
    constructor(params) {
        this.version = params.version || '2017-09-01';
        this.service = params.service.toLowerCase();
        this.noCacheFetch = params.noCacheFetch || false;
        const cloud = params.cloud || config_1.Config.cloud;
        const stage = params.stage || config_1.Config.stage;
        this.isFixedUrl = !!(params.url || stage);
        this.baseUrl = params.url || config_1.Config.createServiceUrl({
            service: this.service,
            version: this.version,
            cloud,
            stage,
        });
        this.http = params.http || config_1.Config.httpService;
        this.hostCache = params.hostCache || config_1.Config.hostCache;
    }
    request(params) {
        return __awaiter(this, void 0, void 0, function* () {
            params.options = params.options || {};
            let { method, headers, body, options } = params;
            const requestOptions = Object.assign({ method }, options);
            requestOptions.headers = Object.assign({}, headers, options.headers);
            if (body) {
                requestOptions.body = body;
            }
            const url = yield this.getRequestUrl(params);
            return yield this.http.request(Object.assign({ url }, requestOptions));
        });
    }
    getRequestUrl(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlObj = url_1.parse(params.path, true);
            urlObj.query = Object.assign({}, urlObj.query, params.query, params.options.query);
            urlObj.search = decodeUriComponent(querystring_1.stringify(urlObj.query));
            return (yield this.getBaseUrl()) + url_1.format(urlObj);
        });
    }
    getBaseUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isFixedUrl) {
                return this.baseUrl;
            }
            else {
                const host = yield this.hostCache.getServiceHost({
                    service: this.service,
                    noCacheFetch: this.noCacheFetch
                });
                return utils_1.Utils.isBlank(host) ? this.baseUrl : `https://${host}/${this.version}`;
            }
        });
    }
}
exports.ServiceRequester = ServiceRequester;
//# sourceMappingURL=service-requester.js.map